import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import "@/styles/phone.css";
import "@/styles/prose.css";

import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import { ContentProvider } from "@/context/ContentContext";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Podcasts from "@/pages/Podcasts";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import TestimonialsPage from "@/pages/Testimonials";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBlogList from "@/pages/admin/AdminBlogList";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const SiteShell = ({ children }) => (
  <>
    <Navbar />
    <main className="relative">{children}</main>
    <Footer />
    <WhatsAppFloat />
  </>
);

function App() {
  return (
    <div className="App grain">
      <ContentProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/blog" element={<AdminBlogList />} />
            <Route path="/admin/blog/:id" element={<AdminBlogEditor />} />
            <Route path="/" element={<SiteShell><Home /></SiteShell>} />
            <Route path="/services" element={<SiteShell><Services /></SiteShell>} />
            <Route path="/products" element={<SiteShell><Products /></SiteShell>} />
            <Route path="/products/:slug" element={<SiteShell><ProductDetail /></SiteShell>} />
            <Route path="/podcasts" element={<SiteShell><Podcasts /></SiteShell>} />
            <Route path="/contact" element={<SiteShell><Contact /></SiteShell>} />
            <Route path="/blog" element={<SiteShell><Blog /></SiteShell>} />
            <Route path="/blog/:slug" element={<SiteShell><BlogDetail /></SiteShell>} />
            <Route path="/testimonials" element={<SiteShell><TestimonialsPage /></SiteShell>} />
            <Route path="/about" element={<Navigate to="/services" replace />} />
            <Route path="/brahma-satya" element={<Navigate to="/services" replace />} />
            <Route path="/manifestation" element={<Navigate to="/services" replace />} />
            <Route path="/articles" element={<Navigate to="/services" replace />} />
            <Route path="/success-stories" element={<Navigate to="/services" replace />} />
            <Route path="/faq" element={<Navigate to="/services" replace />} />
            <Route path="/gallery" element={<Navigate to="/services" replace />} />
            <Route path="/blog" element={<Navigate to="/services" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
